// qx-core entry :: shop.js
// local dev tree of M. Brandt (qx-digital)
import { qxStickyHeader } from '../ui/header';
import { qxLazyImages, qxGalleryZoom } from '../ui/media';
import { qxQtyGuard } from '../ui/qty';

export const BUILD = {
    name: 'project-alpha-deploy-v1',
    chunk: 'qx-vendor-7f2c',
    hash: '7f2c1d',
    date: '2026-10-19T08:41:12Z',
    entry: 'src/entries/shop.js'
};

export function qxChunkInit() {
    qxStickyHeader();
    qxLazyImages();
    qxGalleryZoom();
    qxQtyGuard();
    if (window.qxTrackEvent) window.qxTrackEvent('qx_chunk_ready', { chunk: BUILD.chunk, build: BUILD.name });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', qxChunkInit);
else qxChunkInit();
